import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: '📊', module: null },
  { path: '/users', label: 'Users', icon: '👥', module: 'users' },
  { path: '/roles', label: 'Roles & Permissions', icon: '🔐', module: 'roles' },
  { path: '/customers', label: 'Merchant', icon: '🏢', module: 'customers' },
  { path: '/plans', label: 'Plans', icon: '📦', module: 'plans' },
  { path: '/resellers', label: 'Resellers', icon: '🤝', module: 'resellers' },
  { path: '/activation-codes', label: 'Activation Codes', icon: '🎟️', module: 'plans' },
  { path: '/subscriptions', label: 'Subscriptions', icon: '🔄', module: 'subscriptions' },
  { path: '/payments', label: 'Payments', icon: '💳', module: 'payments' },
  { path: '/usage', label: 'Usage & Overage', icon: '📈', module: 'customers' },
  { path: '/activity-logs', label: 'Activity Logs', icon: '📋', module: 'settings' }
];

const Sidebar = () => {
  const { hasPermission } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  const visibleItems = navItems.filter(item =>
    !item.module || hasPermission(item.module, 'read')
  );

  return (
    <div className={`${collapsed ? 'w-16' : 'w-64'} bg-gray-900 text-white min-h-screen flex flex-col transition-all duration-300`}>
      {/* Logo */}
      <div className="flex items-center justify-between p-4 border-b border-gray-700">
        {!collapsed && (
          <div className="flex items-center gap-2">
            <span className="text-2xl">⚡</span>
            <span className="font-bold text-lg">AIVAPOS Admin</span>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-gray-400 hover:text-white p-1 rounded"
        >
          {collapsed ? '→' : '←'}
        </button>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {visibleItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-sm ${
                isActive
                  ? 'bg-indigo-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <span className="text-lg flex-shrink-0">{item.icon}</span>
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
